<template>
  <v-container fluid style="height: 100%;">
    <v-row>
      <v-col cols="12" align="left">
        <h3 style="font-weight: 500;">
          <v-icon :color="colorTheme">mdi-account</v-icon>
          {{ $t("manageoperators") }}
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="3" sm="4" cols="12" style="padding-bottom: 0; max-height: 60px;">
        <v-text-field
          solo
          :label="$t('search')"
          append-icon="mdi-magnify"
          single-line
          v-model="search"
          :color="colorTheme"
        ></v-text-field>
      </v-col>
      <v-col lg="2" md="3" sm="4" cols="12" style="padding-bottom: 0;">
        <v-select
          :items="opcionesvinc"
          solo
          :color="colorTheme"
          v-model="filterVin"
          :label="$t('filterVehicles')"
        ></v-select>
      </v-col>
      <v-col lg="2" md="3" sm="4" cols="12" style="padding-bottom: 0;">
        <v-btn
          style="width: 100%; margin: 0;"
          large
          :color="colorTheme"
          class="white--text"
          v-on:click="openAddOperator()"
        >
          {{ $t("addoperator").toUpperCase() }}
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col lg="12" sm="12" md="12">
        <v-data-table
          :no-data-text="$t('noResults')"
          v-model="allOperators"
          :headers="headersOperatorsDetails"
          :items="listOperators"
          :search="search"
          show-select
          item-key="id"
          :items-per-page="5"
          class="elevation-1"
          :loading="progressOp"
          :loading-text="$t('loadingTextForTable')"
          :footer-props="{
            'items-per-page-text': $t('rows'),
            'items-per-page-all-text': $t('all')
          }"
        >
          <template v-slot:item.Operator="{ item }">
            <td
              style="display: block; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.Operator }}</td>
          </template>
          <template v-slot:item.License="{ item }">
            <td
              style="display: block; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.License }}</td>
          </template>
          <template v-slot:item.Type="{ item }">
            <td
              style="display: block; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.Type }}</td>
          </template>
          <template v-slot:item.LicenseExpiration="{ item }">
            <td
              style="display: block; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.LicenseExpiration }}</td>
          </template>
          <template v-slot:item.Address="{ item }">
            <td
              style="display: block; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.Address }}</td>
          </template>
          <template v-slot:item.RegistrationDate="{ item }">
            <td
              style="display: block; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.RegistrationDate }}</td>
          </template>
          <template v-slot:item.Bonding="{ item }">
            <td
              style="display: block; padding: 15px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >{{ item.Bonding }}</td>
          </template>
          <template v-slot:item.act="{ item }">
            <td
              style="display: block; padding: 8px; border-bottom: none; padding-left: 0;"
              v-on:mouseover="selectItem(item)"
              v-on:mouseleave="unSelectItem()"
            >
              <v-menu bottom left z-index="18" nudge-width="100">
                <template v-slot:activator="{ on }">
                  <v-btn :color="colorTheme" icon text v-on="on">
                    <v-icon v-show="item === selectedItem || visible == false">mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="item.Bonding == 'N/A'"
                    :color="colorTheme"
                    v-on:click="vincular(item)"
                    dense
                  >
                    <v-list-item-title>{{ $t("link") }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-else :color="colorTheme" dense v-on:click="desvincular(item)">
                    <v-list-item-title>{{ $t("unlink") }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item :color="colorTheme" dense v-on:click="editOperator(item)">
                    <v-list-item-title>{{ $t("edit") }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item :color="colorTheme" dense v-on:click="deleteOperator(item)">
                    <v-list-item-title>{{ $t("delete") }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
          >{{ $t("noResults") }} : "{{ search }}".</v-alert>
          <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }} </template>
        </v-data-table>
      </v-col>
      <v-dialog v-model="addnew" max-width="600">
        <v-card>
          <v-card-title class="headline">{{ $t("newOperator").toUpperCase() }}</v-card-title>
          <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
          <v-card-text>
            <v-container>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <v-col lg="12" md="12" sm="12" cols="12">
                    <v-text-field
                      :label="$t('name')"
                      v-model="name"
                      :rules="nameRules"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col lg="12" md="12" sm="12" cols="12">
                    <v-text-field
                      :label="$t('license')"
                      :rules="licenseRules"
                      v-model="license"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col lg="4" md="4" sm="12" cols="12">
                    <v-select
                      :label="$t('typeoflicense')"
                      :items="typeLicense"
                      item-text="Name"
                      item-value="id"
                      v-model="typeoflicense"
                      outlined
                      required
                    ></v-select>
                  </v-col>
                  <v-col lg="8" md="8" sm="12" cols="12">
                    <v-menu
                      :close-on-content-click="false"
                      offset-y
                      v-model="menuDate"
                      :min-width="290"
                      style="width:100%;"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="expirationDate"
                          style="width: 100%;"
                          outlined
                          readonly
                          :rules="expirationRules"
                          :label="$t('expirationDate')"
                          :color="colorTheme"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        style="min-width: 290px; display: grid;"
                        v-model="expiration"
                        no-title
                        :color="colorTheme"
                        :locale="this.$i18n.locale"
                        @click="menuDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col lg="12" md="12" sm="12" cols="12">
                    <v-text-field
                      :label="$t('address')"
                      v-model="address"
                      :rules="addressRules"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :color="colorTheme"
              text
              v-on:click="cancelOperator()"
            >{{ $t("cancel").toUpperCase() }}</v-btn>
            <v-btn
              :color="colorTheme"
              text
              v-on:click="addOperator()"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editOp" max-width="600">
        <v-card>
          <v-card-title class="headline">{{ $t("editOperator").toUpperCase() }}</v-card-title>
          <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
          <v-card-text>
            <v-container>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <v-col lg="12" md="12" sm="12" cols="12">
                    <v-text-field
                      :label="$t('name')"
                      v-model="name"
                      :rules="nameRules"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col lg="12" md="12" sm="12" cols="12">
                    <v-text-field
                      :label="$t('license')"
                      :rules="licenseRules"
                      v-model="license"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col lg="4" md="4" sm="12" cols="12">
                    <v-select
                      :label="$t('typeoflicense')"
                      :items="typeLicense"
                      item-text="Name"
                      item-value="id"
                      v-model="typeoflicense"
                      outlined
                      required
                    ></v-select>
                  </v-col>
                  <v-col lg="8" md="8" sm="12" cols="12">
                    <v-menu
                      :close-on-content-click="false"
                      offset-y
                      v-model="menuDate"
                      :min-width="290"
                      style="width:100%;"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="expirationDate"
                          style="width: 100%;"
                          outlined
                          readonly
                          :rules="expirationRules"
                          :label="$t('expirationDate')"
                          :color="colorTheme"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        style="min-width: 290px; display: grid;"
                        v-model="expiration"
                        no-title
                        :color="colorTheme"
                        :locale="this.$i18n.locale"
                        @click="menuDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col lg="12" md="12" sm="12" cols="12">
                    <v-text-field
                      :label="$t('address')"
                      v-model="address"
                      :rules="addressRules"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :color="colorTheme"
              text
              v-on:click="cancelOperator()"
            >{{ $t("cancel").toUpperCase() }}</v-btn>
            <v-btn
              :color="colorTheme"
              text
              v-on:click="confirmEdit()"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="confirm" hide-overlay persistent width="365">
        <v-card>
          <v-card-title
            class="headline"
            style="font-size: 14px !important;"
          >{{ $t("deleteConfirmOp").toUpperCase() }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="padding-top: 11px;">
            {{
            delOperator.Operator
            }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :color="colorTheme"
              @click="confirm = false"
              v-on:click="confirmation(false)"
            >{{ $t("cancel").toUpperCase() }}</v-btn>
            <v-btn
              text
              :color="colorTheme"
              @click="confirm = false"
              v-on:click="confirmation(true)"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="restriction" hide-overlay persistent width="330">
        <v-card>
          <v-card-title class="headline" style="font-size: 14px !important;">{{ titleRestriction }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :color="colorTheme" @click="restriction = false">
              {{
              $t("accept").toUpperCase()
              }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="linkup" max-width="750">
        <v-card>
          <v-card-title class="headline">{{ $t("selectMobileEquipment").toUpperCase() }}</v-card-title>
          <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
          <v-card-text>
            <v-container style="padding-top: 17px;">
              <v-row>
                <div
                  class="text--primary"
                  style="font-weight: 500; font-size: 25px;"
                >{{ $t("operator") }}:</div>
                <div class="text--primary ml-2" style="font-size: 23px;">{{ itemOperator.Operator }}</div>
              </v-row>
            </v-container>
            <v-row>
              <v-col lg="6" md="6" sm="12" cols="12" style="padding-bottom: 0;">
                <v-text-field
                  solo
                  :label="$t('search')"
                  append-icon="mdi-magnify"
                  v-model="searchMovil"
                  :color="colorTheme"
                ></v-text-field>
              </v-col>
              <v-col cols="12" style="padding-top: 0;">
                <v-data-table
                  :no-data-text="$t('noResults')"
                  v-model="selected"
                  :headers="headersMovil"
                  :items="listMovil"
                  :search="searchMovil"
                  single-select
                  item-key="IMEI"
                  show-select
                  :items-per-page="5"
                  class="elevation-1"
                  :footer-props="{
                    'items-per-page-text': $t('rows'),
                    'items-per-page-all-text': $t('all')
                  }"

                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.mobile }}</td>
                    <td class="text-xs-center">{{ props.item.IMEI }}</td>
                    <td class="text-xs-center">{{ props.item.model }}</td>
                    <td class="text-xs-center">{{ props.item.OS }}</td>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="error"
                    icon="mdi-alert"
                  >{{ $t("noResults") }} : "{{ searchMovil }}".</v-alert>
                  <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }} </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn :color="colorTheme" text @click="linkup = false">{{ $t("cancel").toUpperCase() }}</v-btn>

            <v-btn
              :color="colorTheme"
              text
              @click="linkupMovil(selected)"
            >{{ $t("link").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="openDesvincular" hide-overlay persistent width="505">
        <v-card>
          <v-card-title class="headline">{{ $t("unlink").toUpperCase() }}</v-card-title>
          <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
          <v-card-text style="padding-top: 11px;">
            <v-list-item three-line>
              <v-row>
                <v-col lg="4" md="4" sm="12" cols="12">
                  <v-list-item-content align="center">
                    <v-list-item-title
                      class="headline"
                      style="font-size: 20px !important; padding-bottom: 8px;"
                    >{{ $t("operator") }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{
                      itemOperator.Operator
                      }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-col>
                <v-col lg="4" md="4" sm="12" cols="12" align="center" style="padding-top: 25px;">
                  <v-img
                    v-if="!this.$vuetify.theme.dark"
                    src="../assets/Desvincular-black.png"
                    alt="Sunny image"
                    width="80"
                  ></v-img>
                  <v-img
                    v-if="this.$vuetify.theme.dark"
                    src="../assets/Desvincular-white.png"
                    alt="Sunny image"
                    width="80"
                  ></v-img>
                </v-col>
                <v-col lg="4" md="4" sm="12" cols="12">
                  <v-list-item-content align="center">
                    <v-list-item-title
                      class="headline"
                      style="font-size: 20px !important; padding-bottom: 8px;"
                    >{{ $t("mobileEquipment") }}</v-list-item-title>
                    <v-list-item-subtitle>{{ number }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :color="colorTheme"
              @click="confirm = false"
              v-on:click="confirmDesv(false)"
            >{{ $t("cancel").toUpperCase() }}</v-btn>
            <v-btn
              text
              :color="colorTheme"
              @click="confirm = false"
              v-on:click="confirmDesv(true)"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
import moment from "moment";
export default {
  name: "operator",
  data() {
    return {
      search: "",
      selectedItem: false,
      addnew: false,
      editOp: false,
      valid: true,
      name: "",
      nameRules: [v => !!v || this.$t("required")],
      license: "",
      licenseRules: [v => !!v || this.$t("required")],
      typeoflicense: 0,
      expirationDate: "",
      expiration: "",
      expirationRules: [v => !!v || this.$t("required")],
      address: "",
      addressRules: [v => !!v || this.$t("required")],
      menuDate: false,
      itemOperator: [],
      confirm: false,
      delOperator: {},
      titleRestriction: "",
      restriction: false,
      linkup: false,
      searchMovil: "",
      selected: [],
      openDesvincular: false,
      number: "",
      opcionesvinc: [i18n.t("all"), i18n.t("entail"), i18n.t("noEntail")],
      typeLicense: [
        { id: 0, Name: i18n.t("other") },
        { id: 1, Name: "A" },
        { id: 2, Name: "B" },
        { id: 3, Name: "C" },
        { id: 4, Name: "D" },
        { id: 5, Name: "E" },
        { id: 6, Name: "F" }
      ]
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.commit("setTitle", this.$t("traffic"));
    this.$store.dispatch("getCarrierInfo");
    this.$store.commit("setPageHeader", [
      this.$t("entailment"),
      "",
      "",
      "",
      true
    ]);
    this.$store.dispatch("ListofOperators");
    this.$store.dispatch("ListOfTraffic");
  },
  computed: {
    ...mapState([
      "colorTheme",
      "headersOperatorsDetails",
      "allOperators",
      "listOperators",
      "progressOp",
      "visible",
      "valueDeterminate",
      "listMovil",
      "headersMovil"
    ]),
    filterVin: {
      get: function() {
        return this.$store.state.filterVin;
      },
      set: function(val) {
        this.$store.commit("filterVin", val);
        this.$store.dispatch("ListofOperators");
        // console.log(val);
      }
    }
  },
  watch: {
    expiration(val) {
      this.expirationDate = moment(val).format("DD/MM/YYYY");
    }
  },
  methods: {
    openAddOperator() {
      this.typeoflicense = 0;
      this.addnew = true;
    },
    vincular(val) {
      this.itemOperator = JSON.parse(JSON.stringify(val));
      this.linkup = true;
      this.$store.dispatch("ListofMovil");
    },
    desvincular(val) {
      this.itemOperator = val;
      this.number = this.itemOperator.Bonding;
      //  console.log(this.itemOperator.Bonding);
      this.openDesvincular = true;
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    addOperator() {
      if (this.$refs.form.validate()) {
        var item = {
          name: this.name,
          licenseId: this.license,
          licenseType: this.typeoflicense,
          licenseExp: this.expiration,
          Address: this.address
        };

        this.$store.dispatch("AddDriver", item);

        this.$refs.form.reset();
        this.addnew = false;
      }
    },
    cancelOperator() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.addnew = false;
      this.editOp = false;
    },
    editOperator(val) {
      this.itemOperator = JSON.parse(JSON.stringify(val));
      this.name = val.Operator;
      this.license = val.License;
      this.typeoflicense =
        val.Type == "A"
          ? 1
          : val.Type == "B"
          ? 2
          : val.Type == "C"
          ? 3
          : val.Type == "D"
          ? 4
          : val.Type == "E"
          ? 5
          : val.Type == "F"
          ? 6
          : 0;
      this.expiration = val.LicenseExpiration;
      this.address = val.Address;
      this.editOp = true;
    },
    confirmEdit() {
      var item = {
        id: this.itemOperator.id,
        name: this.name,
        licenseId: this.license,
        licenseType: this.typeoflicense,
        licenseExp: this.expiration,
        Address: this.address,
        Bonding: this.itemOperator.Bonding
      };

      this.$store.dispatch("EditOperator", item);

      this.$refs.form.reset();
      this.editOp = false;
    },
    deleteOperator(val) {
      // console.log(val);
      if (val.Bonding != "N/A") {
        this.titleRestriction = this.$t("restrictionMovil");
        this.restriction = true;
      } else {
        this.delOperator = val;
        this.confirm = true;
      }
    },
    confirmation(val) {
      if (val) {
        // console.log(this.delOperator.id);
        this.$store.dispatch("DeleteOperator", this.delOperator.id);
      }
    },
    linkupMovil(val) {
      //   console.log(val);
      var item = {
        id: this.itemOperator.id,
        name: this.itemOperator.Operator,
        licenseId: this.itemOperator.License,
        licenseType: this.itemOperator.Type,
        licenseExp: this.itemOperator.LicenseExpiration,
        Address: this.itemOperator.Address,
        Bonding: val[0].IMEI
      };
      this.$store.dispatch("EditOperator", item);
      this.linkup = false;
    },
    confirmDesv(val) {
      if (!val) {
        this.openDesvincular = false;
      } else {
        // console.log(this.itemOperator);
        var item = {
          id: this.itemOperator.id,
          name: this.itemOperator.Operator,
          licenseId: this.itemOperator.License,
          licenseType: this.itemOperator.Type,
          licenseExp: this.itemOperator.LicenseExpiration,
          Address: this.itemOperator.Address,
          Bonding: ""
        };
        this.$store.dispatch("EditOperator", item);
        this.openDesvincular = false;
      }
    }
  }
};
</script>
